<template>
  <div id="order-ai-container-detail">
    <iframe
      frameborder="1"
      width="100%"
      :height="`${height}px`"
      scrolling="no"
      :src="`${VUE_APP_BASE_AUTH_MODULE}/order/data-order-ai/${id}?from=${params}`"
      allow="clipboard-read; clipboard-write"
    />
  </div>
</template>
<script>

export default {
  data() {
    return {
      VUE_APP_BASE_AUTH_MODULE: process.env.VUE_APP_BASE_AUTH_MODULE,
      dataOrder: {},
      height: 0,
      url: '',
      id: this.$route.params.id,
      params: this.$route.query.from,
    }
  },
  mounted() {
    window.addEventListener('message', event => {
      if (event.origin === this.VUE_APP_BASE_AUTH_MODULE) {
        const {
          type, data,
        } = event.data
        if (type === 'SET_DIMENSION') {
          this.height = Math.floor(data.height)
        }
      }
    })
  },

}
</script>
